angular.module('gym.mobile_app').controller('EditProximityCheckinAddressCtrl', ["$scope", "$modalInstance", "ProximityCheckinLocations", "flash", "address", "meta", function($scope, $modalInstance, ProximityCheckinLocations, flash, address, meta) {
  var save;
  $scope.address = address;
  $scope.googleMapsUrl = `https://maps.googleapis.com/maps/api/js?key=${meta.google_maps_api_key}`;
  if (address.latitude) {
    $scope.mapParams = {
      latitude: address.latitude,
      longitude: address.longitude
    };
  }
  $scope.loadCoordinates = _.debounce(function(address) {
    return ProximityCheckinLocations.doGET('geocode', {
      address: address
    }).then(function(response) {
      $scope.mapParams = {
        latitude: response.latitude,
        longitude: response.longitude
      };
      $scope.address.latitude = response.latitude;
      $scope.address.longitude = response.longitude;
      return $scope.address.display_name = address;
    });
  }, 1500);
  $scope.onMarkerChange = function(marker) {
    var latLng;
    latLng = marker.latLng;
    $scope.address.latitude = latLng.lat();
    return $scope.address.longitude = latLng.lng();
  };
  save = function() {
    if ($scope.address.id) {
      return $scope.address.save();
    } else {
      return ProximityCheckinLocations.post($scope.address);
    }
  };
  $scope.save = function() {
    $scope.isLoading = true;
    return save().then(function(data) {
      flash.success = 'Proximity check-in address saved successfully';
      return $modalInstance.close();
    }, function() {
      return $scope.isLoading = false;
    });
  };
  $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
  return $scope.isValid = function() {
    return !$scope.isLoading && $scope.address.display_name && $scope.address.latitude && $scope.address.longitude;
  };
}]);
